export const GOOGLE_ADS_ID = "AW-18329504478";

// The conversion's `send_to` value from Google Ads (ID / conversion label).
export const REGISTRATION_CONVERSION_SEND_TO =
  "AW-18329504478/nShbCPWe-9EcEN6VmKRE";

/**
 * Fires the Google Ads registration conversion.
 *
 * Attribution to the original ad click works automatically across the
 * ordinex.sk → app.ordinex.sk boundary because gtag stores the GCLID in a
 * first-party cookie (`_gcl_aw`) scoped to the root domain `.ordinex.sk`.
 *
 * Whether this fires with cookies (deterministic) or cookieless (modeled)
 * depends on the Consent Mode state, which we sync from the shared
 * `ordinex_consent` cookie in the gtag bootstrap (see GoogleAdsTag).
 */
export function trackRegistrationConversion() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: REGISTRATION_CONVERSION_SEND_TO,
  });
}
